import Create from './create/CreateBlobConnection';
import Edit from './edit/EditBlobConnection';
import Individual from './individual/BlobConnection';

export default { Edit, Create, Individual };
